exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Development/Angular/grim3212.com/src/app/containers/grim-pack/display-stack/display-stack.component.css
// module id = ../../../../../src/app/containers/grim-pack/display-stack/display-stack.component.css
// module chunks = main